import CustomerSearch from './CustomerSearch';

export default CustomerSearch;
